<template>
  <div class="buttons has-addons">
    <slot></slot>
  </div>
</template>